import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Title = styled.div``;

export const H4 = styled.p`
    font-size: 24px;
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentFilter = styled.div`
    display: flex;
    gap: 16px;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    padding: 8px;
    
    border-radius: 4px;
    gap: 8px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;